import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './locales/i18n';
import { Layout } from './features/Layout'; // 引入你写好的 Layout
import Home from './pages/Home';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* 将 Layout 作为父路由，它包含了 Header 和 Footer */}
        <Route path="/" element={<Layout />}>
          
          {/* index 表示默认子路由。
              这里的 element 会被渲染到 Layout 组件的 <Outlet /> 位置 */
              /* Index 路由，默认渲染 Home 页面 */
              }
              
          <Route 
            index 
            element={<Home />} 
          />
          
          {/* 你后续可以在这里继续添加其他页面，例如：
          <Route path="about" element={<AboutPage />} /> 
          */}
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;